export const RESP_INSCRIPTO = 1